// extracted by mini-css-extract-plugin
export default {"cardRow":"Word_cardRow__mF8Q1"};